'use client'

import { useState } from 'react'
import { Container, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { useTracking } from '@marketplace-web/shared/event-tracker'

import { Screen } from 'constants/tracking/screens'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { clickEvent } from '_libs/common/event-tracker/events'

import AddCountryUinForm from '../AddCountryUinForm'
import ConfirmationModal from '../ConfirmationModal'

type Props = {
  show: boolean
  onClose: () => void
  refetch: () => void
}

const AddCountryUinModal = ({ show, onClose, refetch }: Props) => {
  const translate = useTranslate('epr_settings.add_uin_modal')
  const { track } = useTracking()

  const [isDiscardModalVisible, setIsDiscardModalVisible] = useState(false)

  const handleCancel = () => {
    setIsDiscardModalVisible(true)
  }

  const handleConfirmationDiscardClick = () => {
    track(
      clickEvent({
        target: ClickableElement.DiscardAddEprUin,
        screen: Screen.EprSettings,
      }),
    )
    onClose()
    setIsDiscardModalVisible(false)
  }

  const handleConfirmationCloseClick = () => {
    setIsDiscardModalVisible(false)
  }

  const renderUinText = () => (
    <Container>
      <Text
        as="h1"
        text={translate('title')}
        type={Text.Type.Heading}
        alignment={Text.Alignment.Left}
        width={Text.Width.Parent}
      />
      <Spacer size={Spacer.Size.XLarge} />
      <Text
        as="span"
        text={translate('description')}
        type={Text.Type.Body}
        alignment={Text.Alignment.Left}
        width={Text.Width.Parent}
      />
    </Container>
  )

  return (
    <>
      <Dialog show={show} hasScrollableContent testId="add-uin-modal">
        <div className="u-overflow-auto u-fill-width">
          {renderUinText()}
          <AddCountryUinForm onCancel={handleCancel} onClose={onClose} refetch={refetch} />
        </div>
      </Dialog>
      {isDiscardModalVisible && (
        <ConfirmationModal
          onConfirm={handleConfirmationDiscardClick}
          onClose={handleConfirmationCloseClick}
          isVisible={isDiscardModalVisible}
          title={translate('discard_confirmation.title')}
          body={translate('discard_confirmation.body')}
          confirmCtaText={translate('discard_confirmation.confirm_cta')}
          cancelCtaText={translate('discard_confirmation.cancel_cta')}
        />
      )}
    </>
  )
}

export default AddCountryUinModal
